class OffersListController {

  constructor($scope, $state, offerService, messageService, access) {
    this.$scope = $scope;
    this.$state = $state;
    this.offerService = offerService;
    this.messageService = messageService;
    this.access = access;
  }

  $onInit() {
    this.updatePaging();
    this.$scope.$watch(
      function (scope) {
        return scope.current_page;
      },
      function (newVal, oldVal, scope) {
        if (newVal !== oldVal){
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered){
            scope.$ctrl.offers = undefined;
            scope.$ctrl.offerService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
              scope.$ctrl.offers = response;
              scope.$ctrl.loading = false;
            });
          }
          else{
            scope.$ctrl.offerService.findAll(newVal, scope.per_page)
              .then(list => scope.$ctrl.offers = list);
          }
        }
      }
    );
  }

  updatePaging(){
    this.$scope.per_page = this.offers.per_page;
    this.$scope.current_page = this.offers.current_page;
    this.$scope.total = this.offers.total;
  }

  onDelete(offer) {
    this.offerService.delete(offer.id)
      .then(() => {
        this.messageService.success(`The special offer <strong>${offer.name}</strong> was successfully deleted.`);
        this.messageService.push();
      })
      .catch((error) => {
        this.messageService.failure(`The special offer <strong>${offer.name}</strong> could not be successfully deleted: ${error.statusText}`);
        this.messageService.push();
      })
      .then(() => {
        let page = this.offers.current_page;
        this.offers = [];
        this.loading = true;
        return this.offerService.findAll(page).then(response => {
            this.offers = response;
            this.loading = false;
        });
      });
  }

  filter(){
    if (!this.loading && this.filtertext){
      this.isFiltered = true;
      this.offers = undefined;
      this.loading = true;
      this.offerService.search(this.filtertype, this.filtertext).then(response => {
        this.offers = response;
        this.updatePaging();
        this.loading = false;
      });
    }
  }

  clearfilter(){
    if (this.isFiltered) {
      this.isFiltered = false;
      this.loading = true;
      this.offerService.findAll(1, 20).then(response => {
        this.offers = response;
        this.$scope.current_page = 1;
        this.$scope.total = response.total;
        this.loading = false;
      });
    }
  }

  filtertypeChange() {
    switch(this.filtertype) {
      case 'status':
        this.filtertext = '1';
        break;
      default:
        this.filtertext = '';
        break;
    }
  }
}

OffersListController.$inject = [ '$scope', '$state', 'offerService', 'messageService', 'access' ];

export default OffersListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/controllers/offer.list.controller.js